import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';

@Component({
  selector: 'app-modal-editar-data-vistoria',
  templateUrl: './modal-editar-data-vistoria.component.html',
  styleUrls: ['./modal-editar-data-vistoria.component.scss']
})
export class ModalEditarDataVistoriaComponent implements OnInit {



  formAgendamento = new FormGroup({
    dataAgendamento: new FormControl('', [Validators.required]),
    periodo: new FormControl('', [Validators.required])
  });

  dataInicioAgendamento;

  @Input() cabecalho: string;

  constructor(
    private laudoService: LaudoUnionService,
    public activeModal: NgbActiveModal) {

      let dataAtual = new Date();
      this.dataInicioAgendamento = {
        day: dataAtual.getDate(),
        month: dataAtual.getMonth()+1,
        year: dataAtual.getFullYear(),
      };
     }

  ngOnInit() {

  }
}
